(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["categorias-bl"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const items = document.querySelectorAll('.cats-bl__item');
    if (!items.length || !('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    // Sólo se ocultan si hay quien las va a volver a enseñar.
    items.forEach((i) => i.classList.add('is-animable'));

    const observador = new IntersectionObserver((entradas) => {
      entradas.forEach((e) => {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-visible');
        observador.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });

    items.forEach((i) => observador.observe(i));

    // Red de seguridad: si en 2 s algo no se ha revelado (pestaña en segundo
    // plano, observer que no dispara), se enseña igual. Nunca en blanco.
    setTimeout(() => items.forEach((i) => i.classList.add('is-visible')), 2000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const campo = document.querySelector('[data-faq-buscar]');
    const lista = document.querySelector('[data-faq-list]');
    if (!campo || !lista) return;

    const contador = document.querySelector('[data-faq-contador]');
    const vacio = document.querySelector('[data-faq-vacio]');
    const limpiar = document.querySelector('[data-faq-limpiar]');
    const items = Array.from(lista.querySelectorAll('[data-faq-item]'));
    const grupos = Array.from(lista.querySelectorAll('.faqp-group'));

    // Sin tildes y en minúsculas: nadie escribe "envío" con tilde al buscar.
    const normal = (s) => s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    const textos = items.map((i) => normal(i.innerText));

    const filtrar = () => {
      const q = normal(campo.value.trim());
      limpiar.hidden = q.length === 0;

      if (!q) {
        items.forEach((i) => { i.hidden = false; });
        grupos.forEach((g) => { g.hidden = false; });
        contador.hidden = true;
        vacio.hidden = true;
        return;
      }

      let visibles = 0;
      items.forEach((item, i) => {
        const casa = textos[i].includes(q);
        item.hidden = !casa;
        if (casa) visibles += 1;
      });

      // Un encabezado de tema sin preguntas debajo sobra: se oculta también.
      grupos.forEach((g) => {
        let hay = false;
        for (let e = g.nextElementSibling; e && !e.classList.contains('faqp-group'); e = e.nextElementSibling) {
          if (e.matches('[data-faq-item]') && !e.hidden) { hay = true; break; }
        }
        g.hidden = !hay;
      });

      contador.hidden = false;
      contador.textContent = visibles === 1
        ? '1 pregunta encontrada'
        : `${visibles} preguntas encontradas`;
      vacio.hidden = visibles > 0;
    };

    campo.addEventListener('input', filtrar);
    campo.addEventListener('keydown', (e) => { if (e.key === 'Escape') { campo.value = ''; filtrar(); } });
    limpiar.addEventListener('click', () => { campo.value = ''; filtrar(); campo.focus(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-bimba"]) return;
  try {
    
  // En móvil las columnas empiezan cerradas; en escritorio, abiertas. Se hace
  // aquí y no en CSS porque `open` es un atributo, no un estilo.
  (() => {
    const cerrarEnMovil = () => {
      const movil = window.matchMedia('(max-width: 989px)').matches;
      document.querySelectorAll('.pie-bl__acordeon').forEach((d, i) => {
        d.open = !movil || i === 0;
      });
    };
    cerrarEnMovil();
    window.addEventListener('resize', cerrarEnMovil);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-bimba"]) return;
  try {
    
  /* La cabecera publica su alto en `--sticky-header-h`. Media docena de sitios
     del tema la usan —la galería fija de la ficha, la barra de filtros, el
     quiz— y NADIE la definía: todos tiraban de su valor de respaldo, que unos
     ponían en 74 px, otros en 90 y otros en 96. Con la cabecera real cerca de
     los 140, los tres se equivocaban.
     Se recalcula al cambiar de tamaño porque en móvil mide otra cosa. */
  (function () {
    var cab = document.querySelector('.cab-bl');
    if (!cab) return;
    var publicar = function () {
      document.documentElement.style.setProperty('--sticky-header-h', Math.round(cab.getBoundingClientRect().height) + 'px');
    };
    publicar();
    window.addEventListener('resize', publicar);
    if (window.ResizeObserver) new ResizeObserver(publicar).observe(cab);
  })();

  (() => {
    const cabecera = document.querySelector('[data-cabecera]');
    if (!cabecera) return;

    const menu = cabecera.querySelector('[data-menu-movil]');
    const velo = cabecera.querySelector('[data-velo]');
    const abrir = cabecera.querySelector('[data-abrir-menu]');
    const cerrar = cabecera.querySelector('[data-cerrar-menu]');

    const abrirMenu = () => {
      cabecera.classList.add('tiene-menu-abierto');
      menu.classList.add('is-abierto');
      menu.removeAttribute('aria-hidden');
      menu.removeAttribute('inert');
      velo.hidden = false;
      requestAnimationFrame(() => velo.classList.add('is-visible'));
      abrir.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      // El foco entra en el panel: si se queda fuera, el teclado sigue
      // navegando la página de detrás y el menú es decorativo.
      menu.querySelector('a, summary, button')?.focus();
    };

    const cerrarMenu = () => {
      menu.classList.remove('is-abierto');
      menu.setAttribute('aria-hidden', 'true');
      // inert saca el panel cerrado del recorrido con teclado: si no, se puede
      // tabular a enlaces que no se ven.
      menu.setAttribute('inert', '');
      velo.classList.remove('is-visible');
      setTimeout(() => { velo.hidden = true; }, 280);
      abrir.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      abrir.focus();
      // Se baja al terminar la transicion: si se quita antes, el panel se ve
      // pasar por debajo de la topbar mientras se cierra.
      setTimeout(() => cabecera.classList.remove('tiene-menu-abierto'), 300);
    };

    // Estado inicial coherente: cerrado y fuera del foco.
    menu.setAttribute('inert', '');

    // El sticky vive en el envoltorio de sección; se marca también por JS para
    // los navegadores sin :has().
    const envoltorio = cabecera.closest('.shopify-section') || cabecera.parentElement;
    if (cabecera.classList.contains('cab-bl--sticky')) envoltorio?.classList.add('es-fija');

    // Sombra y logo algo más pequeño en cuanto se despega de arriba. Nada que
    // cambie la altura: eso movería la página entera.
    let fijaAntes = false;
    const marcarFija = () => {
      const fija = window.scrollY > 12;
      if (fija === fijaAntes) return;
      fijaAntes = fija;
      cabecera.classList.toggle('esta-fija', fija);
    };
    marcarFija();
    window.addEventListener('scroll', marcarFija, { passive: true });

    abrir?.addEventListener('click', abrirMenu);
    cerrar?.addEventListener('click', cerrarMenu);
    velo?.addEventListener('click', cerrarMenu);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && menu.classList.contains('is-abierto')) cerrarMenu();
    });


    // ---------- buscador predictivo ----------
    const form = cabecera.querySelector('[data-buscador]');
    const panel = cabecera.querySelector('[data-bus-panel]');
    if (form && panel) {
      const campo = form.querySelector('input[name="q"]');
      const inicial = panel.querySelector('[data-bus-inicial]');
      const resultados = panel.querySelector('[data-bus-resultados]');
      const cargando = panel.querySelector('[data-bus-cargando]');
      let temporizador;
      let peticion;
      let marcado = -1;

      const abrirPanel = () => {
        panel.classList.add('is-abierto');
        campo.setAttribute('aria-expanded', 'true');
        colocarPanelMovil();
      };

      const cerrarPanel = () => {
        panel.classList.remove('is-abierto');
        campo.setAttribute('aria-expanded', 'false');
        marcado = -1;
      };

      // En movil el panel es fixed: hay que decirle a que altura empieza, que
      // depende de si la topbar sigue en pantalla o ya se ha ido con el scroll.
      const colocarPanelMovil = () => {
        if (window.matchMedia('(min-width: 990px)').matches) {
          panel.style.top = '';
          return;
        }
        const abajo = cabecera.getBoundingClientRect().bottom;
        panel.style.top = `${Math.max(abajo, 0)}px`;
      };

      const opciones = () =>
        Array.from(panel.querySelectorAll('[data-bus-item]')).filter((e) => e.offsetParent !== null);

      const marcar = (paso) => {
        const lista = opciones();
        if (!lista.length) return;
        lista.forEach((e) => e.classList.remove('is-marcado'));
        marcado = (marcado + paso + lista.length) % lista.length;
        const activo = lista[marcado];
        activo.classList.add('is-marcado');
        activo.scrollIntoView({ block: 'nearest' });
      };

      const buscar = async (termino) => {
        peticion?.abort?.();
        peticion = new AbortController();
        cargando.hidden = false;
        try {
          const url = `${window.Shopify?.routes?.root || '/'}search/suggest?q=${encodeURIComponent(termino)}` +
            '&resources[type]=product,collection,query&resources[limit]=6' +
            '&section_id=buscador-sugerencias';
          const r = await fetch(url, { signal: peticion.signal });
          const html = await r.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const bloque = doc.querySelector('.bus-res');
          resultados.innerHTML = bloque ? bloque.outerHTML : '';
          resultados.hidden = !bloque;
          inicial.hidden = !!bloque;
          marcado = -1;
        } catch (e) {
          if (e.name !== 'AbortError') {
            // Si la sugerencia falla, el formulario sigue funcionando: se cierra
            // el panel y el usuario puede pulsar Enter y buscar de verdad.
            resultados.hidden = true;
            inicial.hidden = false;
          }
        } finally {
          cargando.hidden = true;
        }
      };

      campo.setAttribute('role', 'combobox');
      campo.setAttribute('aria-expanded', 'false');
      campo.setAttribute('aria-autocomplete', 'list');

      campo.addEventListener('focus', abrirPanel);
      campo.addEventListener('click', abrirPanel);

      campo.addEventListener('input', () => {
        const termino = campo.value.trim();
        abrirPanel();
        clearTimeout(temporizador);
        if (termino.length < 2) {
          resultados.hidden = true;
          inicial.hidden = false;
          cargando.hidden = true;
          return;
        }
        // 200 ms: por debajo se dispara una peticion por tecla y se nota el
        // parpadeo; por encima se siente lento al escribir.
        temporizador = setTimeout(() => buscar(termino), 200);
      });

      campo.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowDown') { e.preventDefault(); marcar(1); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); marcar(-1); }
        else if (e.key === 'Enter') {
          const lista = opciones();
          if (marcado >= 0 && lista[marcado]) { e.preventDefault(); lista[marcado].click(); }
        } else if (e.key === 'Escape') { cerrarPanel(); campo.blur(); }
      });

      document.addEventListener('click', (e) => {
        if (!form.contains(e.target)) cerrarPanel();
      });

      window.addEventListener('scroll', () => {
        if (panel.classList.contains('is-abierto')) colocarPanelMovil();
      }, { passive: true });
      window.addEventListener('resize', colocarPanelMovil);
    }

    // El contador del carrito se refresca al volver de una página cacheada
    // (atrás del navegador): si no, enseña un número viejo.
    window.addEventListener('pageshow', (e) => {
      if (!e.persisted) return;
      fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)
        .then((r) => r.json())
        .then(({ item_count: total }) => {
          const contador = cabecera.querySelector('[data-carrito-contador]');
          if (!contador) return;
          contador.textContent = total;
          contador.classList.toggle('is-vacio', total === 0);
        })
        .catch(() => {});
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-promos"] && !Shopify.designMode) return;
  try {
    
  class HeroBL {
    constructor(raiz) {
      this.raiz = raiz;
      this.slides = Array.from(raiz.querySelectorAll('[data-hero-slide]'));
      if (this.slides.length < 2) return;

      this.barras = Array.from(raiz.querySelectorAll('[data-hero-ir]'));
      this.indice = 0;
      this.intervalo = parseInt(raiz.dataset.intervalo, 10) || 6000;
      this.autoplay = raiz.dataset.autoplay === 'true';
      this.reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      raiz.style.setProperty('--duracion', `${this.intervalo}ms`);

      raiz.querySelector('[data-hero-prev]')?.addEventListener('click', () => this.ir(this.indice - 1, true));
      raiz.querySelector('[data-hero-next]')?.addEventListener('click', () => this.ir(this.indice + 1, true));
      this.barras.forEach((b) => b.addEventListener('click', () => this.ir(Number(b.dataset.heroIr), true)));

      // Deslizar con el dedo: en móvil es el gesto natural y sin esto el hero
      // es un cartel fijo, porque las flechas están ocultas.
      let inicio = null;
      raiz.addEventListener('touchstart', (e) => { inicio = e.touches[0].clientX; }, { passive: true });
      raiz.addEventListener('touchend', (e) => {
        if (inicio === null) return;
        const delta = e.changedTouches[0].clientX - inicio;
        if (Math.abs(delta) > 45) this.ir(this.indice + (delta < 0 ? 1 : -1), true);
        inicio = null;
      }, { passive: true });

      raiz.addEventListener('mouseenter', () => this.parar());
      raiz.addEventListener('mouseleave', () => this.arrancar());
      // Con el foco dentro (navegación por teclado) no se mueve solo.
      raiz.addEventListener('focusin', () => this.parar());
      raiz.addEventListener('focusout', () => this.arrancar());

      if (this.autoplay && !this.reducido) this.arrancar();
    }

    ir(destino, manual) {
      const total = this.slides.length;
      const nuevo = ((destino % total) + total) % total;

      this.slides[this.indice].classList.remove('is-activo');
      this.slides[this.indice].setAttribute('aria-hidden', 'true');
      this.barras[this.indice]?.classList.remove('is-activo');

      this.indice = nuevo;
      this.slides[nuevo].classList.add('is-activo');
      this.slides[nuevo].removeAttribute('aria-hidden');

      // Reiniciar la barra: sin este reflow forzado la animación no vuelve a
      // arrancar cuando se salta de golpe a otra promo.
      const barra = this.barras[nuevo];
      if (barra) {
        const relleno = barra.querySelector('.hero-bl__barra-relleno');
        if (relleno) {
          relleno.style.transition = 'none';
          relleno.style.width = '0';
          void relleno.offsetWidth;
          relleno.style.transition = '';
        }
        barra.classList.add('is-activo');
      }

      if (manual) this.reiniciar();
    }

    arrancar() {
      if (!this.autoplay || this.reducido) return;
      this.parar();
      this.temporizador = setInterval(() => this.ir(this.indice + 1), this.intervalo);
    }

    parar() { clearInterval(this.temporizador); }
    reiniciar() { this.parar(); this.arrancar(); }
  }

  document.querySelectorAll('[data-hero]').forEach((el) => new HeroBL(el));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pack-a-elegir"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const rutaTienda = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const rellenar = (texto, datos) => texto.replace(/__(\w+)__/g, (_, k) => (k in datos ? datos[k] : ''));

    /* El importe con el formato de la tienda (shop.money_format), como lo
       pinta el filtro `money`: escribir un «€» a mano rompería el día que la
       tienda venda en otra moneda. */
    const formatear = (centimos, formato) => {
      const con = (dec, miles, coma) => {
        const [ent, fr] = (centimos / 100).toFixed(dec).split('.');
        return ent.replace(/\B(?=(\d{3})+(?!\d))/g, miles) + (dec ? coma + fr : '');
      };
      return formato.replace(/\{\{\s*(\w+)\s*\}\}/, (_, tipo) => {
        switch (tipo) {
          case 'amount': return con(2, ',', '.');
          case 'amount_no_decimals': return con(0, ',', '.');
          case 'amount_no_decimals_with_comma_separator': return con(0, '.', ',');
          case 'amount_with_apostrophe_separator': return con(2, "'", '.');
          default: return con(2, '.', ',');
        }
      });
    };

    const iniciar = (raiz) => {
      if (raiz.dataset.listo) return;
      raiz.dataset.listo = '1';

      const cfg = JSON.parse(raiz.querySelector('[data-pack-config]').textContent);
      /* El formato de moneda y los precios ya pintados pueden traer entidades
         HTML (&euro;); el resumen se escribe como texto, así que se decodifican
         una vez aquí. */
      const decodificar = (s) => {
        const t = document.createElement('textarea');
        t.innerHTML = s;
        return t.value;
      };
      cfg.formato = decodificar(cfg.formato);
      const T = {};
      Object.keys(cfg.textos).forEach((k) => { T[k] = decodificar(cfg.textos[k]); });
      const dinero = (c) => formatear(c, cfg.formato);
      const sabores = Array.from(raiz.querySelectorAll('[data-sabor]'));
      const cuenta = new Map();
      const puntos = Array.from(raiz.querySelectorAll('[data-punto]'));
      const estado1 = raiz.querySelector('[data-estado-1]');
      const estado2 = raiz.querySelector('[data-estado-2]');
      const boton = raiz.querySelector('[data-anadir]');
      const botonTexto = raiz.querySelector('[data-boton-texto]');
      const aviso = raiz.querySelector('[data-aviso]');
      let anteriorResto = 0;
      let ocupado = false;

      /* Cajas de la más cara a la más barata; los packs se llevan las caras y
         las que no completan un pack van sueltas. Un grupo que suelto no es
         más caro que el pack no se mete en un pack. */
      const reparto = () => {
        const cajas = [];
        sabores.forEach((el) => {
          const n = cuenta.get(el.dataset.variantId) || 0;
          for (let i = 0; i < n; i += 1) {
            cajas.push({ id: Number(el.dataset.variantId), precio: Number(el.dataset.precio), nombre: el.dataset.nombre, orden: Number(el.dataset.orden) });
          }
        });
        cajas.sort((a, b) => b.precio - a.precio || a.orden - b.orden);
        const packs = [];
        const sueltas = [];
        let i = 0;
        for (; i + cfg.tam <= cajas.length; i += cfg.tam) {
          const grupo = cajas.slice(i, i + cfg.tam);
          const suma = grupo.reduce((s, c) => s + c.precio, 0);
          if (suma > cfg.precioPack) packs.push(grupo);
          else sueltas.push(...grupo);
        }
        sueltas.push(...cajas.slice(i));
        const total = packs.length * cfg.precioPack + sueltas.reduce((s, c) => s + c.precio, 0);
        return { n: cajas.length, packs, sueltas, total };
      };

      const avisar = (texto) => {
        aviso.textContent = texto;
        aviso.hidden = !texto;
      };

      /* «Pack completo» es el momento que importa: el resumen da un pequeño
         salto para que se note. Sólo con GSAP cargado y sin movimiento
         reducido; si no, el texto cambia y ya. */
      let celebrar = () => {};
      const prepararMovimiento = () => {
        if (!window.gsap || prepararMovimiento.hecho) return;
        prepararMovimiento.hecho = true;
        window.gsap.matchMedia().add('(prefers-reduced-motion: no-preference)', () => {
          celebrar = () => {
            window.gsap.fromTo(estado1, { opacity: 0.35, scale: 0.97 }, { opacity: 1, scale: 1, duration: 0.22, ease: 'power3.out', overwrite: true, transformOrigin: 'left center' });
          };
          return () => { celebrar = () => {}; };
        });
      };

      const pintar = () => {
        const r = reparto();
        const resto = r.n % cfg.tam;
        const faltan = resto ? cfg.tam - resto : 0;

        sabores.forEach((el) => {
          const n = cuenta.get(el.dataset.variantId) || 0;
          const salida = el.querySelector('[data-cuenta]');
          if (salida) salida.textContent = n;
          const menos = el.querySelector('[data-menos]');
          if (menos) menos.disabled = n === 0;
          el.classList.toggle('is-elegido', n > 0);
        });

        const llenos = r.n === 0 ? 0 : (resto || cfg.tam);
        puntos.forEach((p, i) => p.classList.toggle('is-lleno', i < llenos));

        let uno;
        let dos;
        if (r.n === 0) {
          uno = T.elige;
          dos = T.eligeSub;
        } else if (r.packs.length && !r.sueltas.length) {
          uno = r.packs.length === 1 ? T.completoUno : rellenar(T.completoVarios, { packs: r.packs.length });
          dos = rellenar(T.completoSub, { cajas: r.n, total: dinero(r.total) });
        } else if (!r.packs.length) {
          uno = r.n === 1 ? T.llevasUna : rellenar(T.llevasVarias, { cajas: r.n });
          dos = faltan === 1 ? T.faltaUna : rellenar(T.faltan, { faltan });
        } else {
          uno = rellenar(T.mixto, {
            packs: r.packs.length === 1 ? T.packUno : rellenar(T.packsVarios, { n: r.packs.length }),
            sueltas: r.sueltas.length === 1 ? T.sueltaUna : rellenar(T.sueltasVarias, { n: r.sueltas.length }),
          });
          dos = faltan === 1 ? T.otroUno : rellenar(T.otroVarios, { faltan });
        }
        estado1.textContent = uno;
        estado2.textContent = dos;

        if (!ocupado) {
          boton.disabled = r.n === 0;
          botonTexto.textContent = r.n === 0 ? T.anadir : rellenar(T.anadirTotal, { total: dinero(r.total) });
        }

        if (r.n > 0 && resto === 0 && anteriorResto === cfg.tam - 1) {
          prepararMovimiento();
          celebrar();
        }
        anteriorResto = resto;
      };

      raiz.addEventListener('click', (e) => {
        const mas = e.target.closest('[data-mas]');
        const menos = e.target.closest('[data-menos]');
        if (!mas && !menos) return;
        const id = (mas || menos).closest('[data-sabor]').dataset.variantId;
        const n = cuenta.get(id) || 0;
        cuenta.set(id, mas ? n + 1 : Math.max(0, n - 1));
        avisar('');
        pintar();
      });

      /* Convierte una respuesta que no es 200 en lo que verá el cliente, como
         las tarjetas (4cb549d): 422 trae el motivo ya traducido; 429 es el
         reto anti-bot de Cloudflare y se arregla recargando. */
      const motivo = (r) => {
        if (r.status === 429 || r.status >= 500) return Promise.resolve(T.errorRecarga);
        return r.json()
          .then((d) => (d && (d.description || d.message)) || T.error)
          .catch(() => T.errorRecarga);
      };

      boton.addEventListener('click', () => {
        const r = reparto();
        if (!r.n || ocupado) return;

        // Packs iguales van en una línea con cantidad: subir la cantidad en el
        // carrito sigue siendo coherente, cada unidad son esas mismas cajas.
        const items = [];
        const porSabores = new Map();
        r.packs.forEach((grupo) => {
          const nombres = grupo.slice().sort((a, b) => a.orden - b.orden).map((c) => c.nombre).join(', ');
          porSabores.set(nombres, (porSabores.get(nombres) || 0) + 1);
        });
        porSabores.forEach((q, nombres) => {
          items.push({ id: cfg.packVariante, quantity: q, properties: { [cfg.propiedad]: nombres } });
        });
        const porId = new Map();
        r.sueltas.forEach((c) => porId.set(c.id, (porId.get(c.id) || 0) + 1));
        porId.forEach((q, id) => items.push({ id, quantity: q }));

        ocupado = true;
        boton.disabled = true;
        botonTexto.textContent = T.anadiendo;
        avisar('');

        // UNA sola llamada con todo: varias seguidas pueden cruzarse y dejar
        // el carrito con algo de menos.
        fetch(rutaTienda() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        })
          .then((resp) => (resp.ok ? resp.json() : motivo(resp).then((m) => Promise.reject(m))))
          .then(() => {
            /* Primero repintar el cajón y luego abrirlo: al revés se abre con el
               carrito de antes y parece que no ha pasado nada. */
            document.addEventListener('cart:pintado', function abrir() {
              document.removeEventListener('cart:pintado', abrir);
              const cajon = document.querySelector('#cart-drawer');
              if (cajon && cajon.showModal && !cajon.open) cajon.showModal();
            });
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            cuenta.clear();
            anteriorResto = 0;
            ocupado = false;
            pintar();
            boton.classList.add('is-hecho');
            botonTexto.textContent = T.anadido;
            boton.disabled = true;
            setTimeout(() => {
              boton.classList.remove('is-hecho');
              pintar();
            }, 1800);
          })
          .catch((m) => {
            ocupado = false;
            avisar(typeof m === 'string' && m ? m : T.error);
            // Un 422 puede haber metido parte: el cajón se repinta con lo que
            // hay de verdad en el servidor, pero sin abrirse.
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            pintar();
          });
      });

      pintar();
    };

    const arrancar = () => document.querySelectorAll('[data-pack]').forEach(iniciar);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
    else arrancar();
    // En el editor del tema la sección se vuelve a pintar al cambiar ajustes.
    document.addEventListener('shopify:section:load', arrancar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prueba-social"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var raiz = document.querySelector('[data-prueba-social]');
    if (!raiz) return;

    /* Si lo has cerrado, no vuelve en toda la visita. Un aviso que reaparece
       después de cerrarlo deja de ser prueba social y pasa a ser publicidad
       que no se puede quitar. */
    try { if (sessionStorage.getItem('ps-cerrado')) return; } catch (e) {}

    var DATOS;
    try { DATOS = JSON.parse(raiz.querySelector('[data-ps-datos]').textContent); } catch (e) { return; }
    if (!DATOS.personas.length || !DATOS.productos.length) return;

    var elPersona = raiz.querySelector('[data-ps-persona]');
    var elProducto = raiz.querySelector('[data-ps-producto]');
    var elHace = raiz.querySelector('[data-ps-hace]');
    var elFoto = raiz.querySelector('[data-ps-foto]');
    var elEnlace = raiz.querySelector('[data-ps-enlace]');

    var visible = Number(raiz.getAttribute('data-visible')) || 6000;
    var intervalo = Number(raiz.getAttribute('data-intervalo')) || 18000;
    var primer = Number(raiz.getAttribute('data-primer-retraso')) || 8000;

    var azar = function (n) { return Math.floor(Math.random() * n); };
    var vistos = [];

    function siguiente() {
      /* No se repite el mismo producto hasta agotar la lista: ver dos veces
         seguidas «X compró el mismo saco» delata que es un carrusel. */
      if (vistos.length >= DATOS.productos.length) vistos = [];
      var i;
      do { i = azar(DATOS.productos.length); } while (vistos.indexOf(i) !== -1);
      vistos.push(i);
      return DATOS.productos[i];
    }

    function pintar() {
      var p = siguiente();
      var q = DATOS.personas[azar(DATOS.personas.length)];
      var min = DATOS.minutos[0];
      var max = DATOS.minutos[1];
      var mins = min + azar(Math.max(1, max - min + 1));

      elPersona.textContent = q.ciudad ? q.nombre + ' de ' + q.ciudad : q.nombre;
      elProducto.textContent = p.titulo;
      elHace.textContent = mins < 60
        ? elHace.getAttribute('data-min').replace('__n__', mins)
        : elHace.getAttribute('data-hora').replace('__n__', Math.round(mins / 60));
      elFoto.src = p.foto;
      elFoto.alt = '';
      elEnlace.href = p.url;

      raiz.hidden = false;
      requestAnimationFrame(function () { raiz.classList.add('is-visible'); });
      setTimeout(esconder, visible);
    }

    function esconder() {
      raiz.classList.remove('is-visible');
      setTimeout(function () { raiz.hidden = true; }, 320);
    }

    raiz.querySelector('[data-ps-cerrar]').addEventListener('click', function () {
      esconder();
      try { sessionStorage.setItem('ps-cerrado', '1'); } catch (e) {}
      clearInterval(bucle);
    });

    var bucle;
    setTimeout(function () {
      pintar();
      bucle = setInterval(pintar, intervalo + visible);
    }, primer);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quiz-ayuda"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var quiz = document.querySelector('[data-quiz]');
    if (!quiz) return;

    var PASOS = ['animal', 'etapa', 'tipo', 'extra'];
    var pasos = {};
    quiz.querySelectorAll('[data-qz-paso]').forEach(function (p) { pasos[p.getAttribute('data-qz-paso')] = p; });

    var pie = quiz.querySelector('[data-qz-pie]');
    var barra = quiz.querySelector('[data-qz-barra]');
    var atras = quiz.querySelector('[data-qz-atras]');
    var siguiente = quiz.querySelector('[data-qz-siguiente]');
    var rejilla = quiz.querySelector('[data-qz-rejilla]');
    var vacio = quiz.querySelector('[data-qz-vacio]');
    var verTodos = quiz.querySelector('[data-qz-ver]');
    var resumen = quiz.querySelector('[data-qz-resumen]');
    var nota = quiz.querySelector('[data-qz-nota]');

    var indice = -1;           // -1 = portada
    var respuestas = {};       // clave -> {valor, col, etiqueta}

    function mostrar(nombre) {
      Object.keys(pasos).forEach(function (k) {
        var activo = k === nombre;
        pasos[k].classList.toggle('is-activo', activo);
        pasos[k].hidden = !activo;
      });
      pie.hidden = nombre === 'intro' || nombre === 'resultado';
      if (!pie.hidden) {
        barra.style.width = ((indice + 1) / PASOS.length) * 100 + '%';
        var clave = pasos[nombre].getAttribute('data-clave');
        siguiente.disabled = !respuestas[clave];
      }
      /* NO se mueve la página en cada respuesta. Con `scrollIntoView` el quiz
         se pegaba al borde superior, la cabecera fija le comía la pregunta y
         había que subir a mano para leerla. Cada paso ya está centrado en
         pantalla, así que no hay a dónde ir; sólo se sube si el quiz se ha
         quedado fuera de la vista. */
      var caja = quiz.getBoundingClientRect();
      if (caja.top < 0 || caja.top > window.innerHeight * 0.5) {
        quiz.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    }

    function ir(i) {
      indice = i;
      if (indice < 0) { mostrar('intro'); return; }
      if (indice >= PASOS.length) { resolver(); return; }
      mostrar(PASOS[indice]);
    }

    quiz.querySelector('[data-qz-empezar]').addEventListener('click', function () { ir(0); });
    atras.addEventListener('click', function () { ir(indice - 1); });
    siguiente.addEventListener('click', function () { ir(indice + 1); });
    quiz.querySelector('[data-qz-reiniciar]').addEventListener('click', function () {
      respuestas = {};
      quiz.querySelectorAll('.qz__op').forEach(function (o) { o.classList.remove('is-elegida'); });
      ir(-1);
    });

    quiz.addEventListener('click', function (e) {
      var op = e.target.closest('.qz__op');
      if (!op) return;
      var paso = op.closest('[data-qz-paso]');
      var clave = paso.getAttribute('data-clave');

      paso.querySelectorAll('.qz__op').forEach(function (o) { o.classList.toggle('is-elegida', o === op); });
      respuestas[clave] = {
        valor: op.getAttribute('data-valor') || '',
        col: op.getAttribute('data-col') || '',
        colPerro: op.getAttribute('data-col-perro') || '',
        colGato: op.getAttribute('data-col-gato') || '',
        etiqueta: op.textContent.trim(),
      };
      /* Se avanza solo: en un quiz de una pregunta por pantalla, obligar a
         pulsar «siguiente» después de elegir es un clic de más en cada paso. */
      siguiente.disabled = false;
      setTimeout(function () { ir(indice + 1); }, 220);
    });

    /* Compone la URL con los filtros REALES de la tienda. La necesidad especial
       manda sobre la etapa: quien busca dieta renal la quiere antes que la
       gama senior. */
    function destino() {
      var animal = respuestas.animal || {};
      var esGato = animal.valor === 'gato';
      var col = animal.col || '';

      ['etapa', 'extra'].forEach(function (k) {
        var r = respuestas[k];
        if (!r) return;
        var c = esGato ? r.colGato : r.colPerro;
        if (c) col = c;
      });

      var params = [];
      var tipo = (respuestas.tipo || {}).valor;
      if (tipo) params.push('filter.p.product_type=' + encodeURIComponent(tipo));
      params.push('filter.v.availability=1');
      return { url: '/collections/' + col + (params.length ? '?' + params.join('&') : ''), col: col };
    }

    function resolver() {
      mostrar('resultado');
      var d = destino();
      resumen.textContent = PASOS
        .map(function (k) { return respuestas[k] && respuestas[k].etiqueta; })
        .filter(Boolean)
        .join(' · ');

      rejilla.innerHTML = '';
      vacio.hidden = true;
      nota.hidden = true;

      /* Se le piden los productos a la propia colección con los filtros
         puestos: lo que se enseña es lo que hay en la tienda. Una lista escrita
         a mano envejece en una semana y acaba mandando a fichas descatalogadas. */
      pedir(d.url).then(function (r) {
        if (r && r.celdas.length) { pintar(d.url, r); return; }

        /* PLAN B, y hace falta: las colecciones de edad («Cachorros»,
           «Gatitos») son ellas mismas un tipo de producto, así que cruzarlas
           con «Comida seca» no deja ni un producto. En vez de un callejón sin
           salida se afloja la condición más estrecha —el tipo— y se dice que se
           ha hecho. Un quiz que acaba en «no hay nada» es peor que no tenerlo. */
        var sinTipo = d.url.replace(/[?&]filter\.p\.product_type=[^&]*/, function (m) {
          return m.charAt(0) === '?' ? '?' : '';
        }).replace('?&', '?');
        if (sinTipo === d.url) { vacio.hidden = false; verTodos.href = d.url; return; }

        pedir(sinTipo).then(function (r2) {
          if (!r2 || !r2.celdas.length) { vacio.hidden = false; verTodos.href = d.url; return; }
          nota.hidden = false;
          pintar(sinTipo, r2);
        });
      });
    }

    function pedir(url) {
      var sep = url.indexOf('?') === -1 ? '?' : '&';
      return fetch(url + sep + 'view=tarjetas')
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (!html) return null;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var cont = doc.querySelector('[data-total]');
          return {
            celdas: Array.prototype.slice.call(doc.querySelectorAll('.cl-cell')),
            total: cont && cont.getAttribute('data-total'),
          };
        })
        .catch(function () { return null; });
    }

    function pintar(url, r) {
      verTodos.href = url;
      r.celdas.slice(0, 4).forEach(function (c) { rejilla.appendChild(c); });
      if (r.total) verTodos.textContent = verTodos.getAttribute('data-base') + ' (' + r.total + ')';
    }

    mostrar('intro');
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["topbar-bimba"] && !Shopify.designMode) return;
  try {
    
  class TopbarBL {
    constructor(raiz) {
      this.raiz = raiz;
      this.mensajes = Array.from(raiz.querySelectorAll('[data-topbar-msg]'));
      if (this.mensajes.length < 2) return;

      this.indice = 0;
      this.intervalo = parseInt(raiz.dataset.intervalo, 10) || 5000;
      this.live = raiz.querySelector('[data-topbar-live]');
      this.botonPausa = raiz.querySelector('[data-topbar-pausa]');
      this.reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      raiz.querySelector('[data-topbar-prev]')?.addEventListener('click', () => {
        this.parar();
        this.mover(-1);
      });
      raiz.querySelector('[data-topbar-next]')?.addEventListener('click', () => {
        this.parar();
        this.mover(1);
      });
      this.botonPausa?.addEventListener('click', () => this.alternar());

      // Pausa al pasar el ratón: si alguien está leyendo el mensaje, cambiárselo
      // debajo es justo lo que no hay que hacer.
      raiz.addEventListener('mouseenter', () => this.parar(true));
      raiz.addEventListener('mouseleave', () => {
        if (!this.pausadoPorUsuario) this.arrancar();
      });

      // No gastar temporizadores con la pestaña en segundo plano.
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.parar(true);
        else if (!this.pausadoPorUsuario) this.arrancar();
      });

      if (!this.reducido) this.arrancar();
    }

    mover(paso) {
      const anterior = this.mensajes[this.indice];
      anterior.hidden = true;
      anterior.classList.remove('is-activo');

      this.indice = (this.indice + paso + this.mensajes.length) % this.mensajes.length;

      const actual = this.mensajes[this.indice];
      actual.hidden = false;
      actual.classList.add('is-activo');
    }

    arrancar() {
      this.parar(true);
      // aria-live solo mientras rota sola: si el usuario navega a mano, el
      // cambio ya lo provoca él y anunciarlo dos veces sobra.
      this.live?.setAttribute('aria-live', 'polite');
      this.temporizador = setInterval(() => this.mover(1), this.intervalo);
    }

    parar(silencioso) {
      clearInterval(this.temporizador);
      if (!silencioso) this.live?.removeAttribute('aria-live');
    }

    alternar() {
      this.pausadoPorUsuario = !this.pausadoPorUsuario;
      this.botonPausa.setAttribute('aria-pressed', String(this.pausadoPorUsuario));
      if (this.pausadoPorUsuario) this.parar();
      else this.arrancar();
    }
  }

  document.querySelectorAll('[data-topbar]').forEach((el) => new TopbarBL(el));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whatsapp-flotante"]) return;
  try {
    
  (() => {
    const boton = document.querySelector('[data-wa-fab]');
    if (!boton) return;

    // La barra fija de "añadir al carrito" se enciende y apaga con JS del tema
    // (style.display), asi que se vigila el atributo en vez de consultarlo una
    // vez al cargar.
    const barra = document.querySelector('[data-sticky-atc]');
    if (!barra) return;

    const ajustar = () => {
      const visible = getComputedStyle(barra).display !== 'none';
      boton.classList.toggle('esta-arriba', visible);
    };

    ajustar();
    new MutationObserver(ajustar).observe(barra, { attributes: true, attributeFilter: ['style', 'class'] });
    window.addEventListener('resize', ajustar);
  })();

  } catch(e) { console.error(e); }
})();
})();
